<template>
  <div class="footer">
    <div v-if="$store.state.isFooterQuestions" class="questions-have">
      <div class="info">
        <span class="title"> {{ $t("general.footer.title") }} </span>
        <span class="title-info">
          {{ $t("general.footer.title-info") }}
        </span>
      </div>

      <BotsMessengerBlock />
    </div>

    <div class="footer-down">
      <div class="left-footer">
        <span>
          <a
            href="https://e-chat.tech/terms/user_agreement.php"
            target="_blank"
          >
            {{ $t("general.footer.left_footer[0]") }}
          </a>
          {{ $t("general.footer.left_footer[1]") }}

          <a
            href="https://e-chat.tech/terms/privacy_policy.php"
            target="_blank"
          >
            {{ $t("general.footer.left_footer[2]") }}
          </a>
        </span>
      </div>

      <div class="right-info">
        <span @dblclick="check"
          >{{ $t("general.footer.right_footer") }}{{ this.currentYear
          }}{{ $t("general.footer.right_footer_end") }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import BotsMessengerBlock from "@/components/blocks/BotsMessengerBlock.vue";

export default {
  name: "MainFooter",
  components: { BotsMessengerBlock },
  data() {
    return {
      currentYear: "",
    };
  },
  methods: {
    printYear: function () {
      return new Date().getFullYear();
    },
    check: function () {
      this.$store.commit("openDialog", {
        name: "SuccessActivationDialog",
        params: "389222242111",
        inf: "3892222",
      });
    },
  },
  mounted() {
    this.currentYear = this.printYear();
  },
};
</script>

<style scoped lang="scss">
.footer {
  padding: 0 20px 20px;
}

.questions-have {
  box-sizing: border-box;
  padding: 29px 33px 29px 83px;

  width: 560px;
  height: 105px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-radius: 9px;
  box-shadow: 0 10px 13px rgba(122, 112, 223, 0.22);
  background-image: url("~@/assets/footer/bg.png");

  .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;

    .title {
      font-size: 24px;
      font-family: "Gilroy";
      font-weight: 500;

      text-transform: uppercase;

      color: var(--text-color);
    }

    .title-info {
      font-size: 14px;
      font-family: "Gilroy";
      font-weight: 500;

      color: #8b8b8bff;
    }
  }
}

.footer-down {
  margin-top: 25px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  span,
  span.a {
    font-size: 14px;
    font-family: "Gilroy";
    font-weight: 500;

    color: rgba(#000000ff, 0.46);
  }
}

@media screen and (max-width: 700px) {
  .questions-have {
    width: 100%;
    height: 100%;
    padding: 15px 30px 15px 83px;
  }
}

@media screen and (max-width: 635px) {
  .questions-have {
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;
    background-repeat: no-repeat;
    padding-right: 10px;

    .info {
      .title {
        font-size: 16px;
      }

      .title-info {
        font-size: 12px;
      }
    }
  }

  .footer-down {
    flex-direction: column;

    span {
      font-size: 10px;
    }
  }
}

@media screen and (max-width: 460px) {
  .questions-have {
    padding-right: 0px;
    padding-left: 70px;

    .info {
      .title {
        font-size: 12px;
      }

      .title-info {
        font-size: 10px;
      }
    }
  }
}
</style>
